import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/app/global-error.tsx");
